import { Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Hero from './pages/components/dashboard/hero';
import About from './pages/components/dashboard/about';
import Service from './pages/components/dashboard/service';
import Contact from './pages/components/dashboard/contact';
import Form from './pages/components/dashboard/form';
import DashTable from './pages/DashTable';
import { TechMarquee, Testimonials, GlowCTA } from './pages/components/dashboard/sections';

/* Full homepage with all sections */
function HomePage() {
  return (
    <>
      <Hero />
      <TechMarquee />
      <Testimonials />
      <GlowCTA />
    </>
  );
}

/* 404 Not Found Page */
function NotFound() {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      textAlign: 'center',
      flexDirection: 'column',
      background: '#050508',
      color: '#f1f0f5',
      fontFamily: "'Syne',sans-serif",
      gap: 20,
    }}>
      <h1 style={{ fontSize: 96, fontWeight: 800, margin: 0, color: '#a855f7' }}>404</h1>
      <p style={{ fontSize: 24, fontWeight: 600, margin: 0 }}>Page not found</p>
      <a href="/" style={{
        marginTop: 20,
        padding: '12px 28px',
        borderRadius: 8,
        background: 'rgba(124,58,237,0.2)',
        border: '1px solid rgba(124,58,237,0.4)',
        color: '#c084fc',
        textDecoration: 'none',
        fontWeight: 600,
        transition: 'all 0.3s ease',
      }}>Return to Home</a>
    </div>
  );
}

function App() {
  return (
    <Routes>
      {/* Main routes - clean SEO-friendly URLs */}
      <Route path="/" element={<Home />}>
        <Route index element={<HomePage />} />
        <Route path="about" element={<About />} />
        <Route path="services" element={<Service />} />
        <Route path="contact" element={<Contact />} />
        <Route path="form" element={<Form />} />
        <Route path="table" element={<DashTable />} />
      </Route>

      {/* Redirects for old /home routes (backwards compatibility) */}
      <Route path="/home" element={<Navigate to="/" replace />} />
      <Route path="/home/about" element={<Navigate to="/about" replace />} />
      <Route path="/home/service" element={<Navigate to="/services" replace />} />
      <Route path="/home/contact" element={<Navigate to="/contact" replace />} />
      <Route path="/home/form" element={<Navigate to="/form" replace />} />
      <Route path="/home/table" element={<Navigate to="/table" replace />} />

      {/* Redirect login/register to homepage */}
      <Route path="/login" element={<Navigate to="/" replace />} />
      <Route path="/register" element={<Navigate to="/" replace />} />

      {/* 404 catch-all route */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
